<template>
  <v-card flat>
    <v-form ref="selectTypesForm" v-model="valid" lazy-validation>
      <v-select
        v-model="select"
        :loading="loading"
        :items="types"
        outlined
        item-text="name"
        item-value="id"
        cache-items
        hide-no-data
        :label="label"
        :placeholder="placeholder"
        :rules="required ? [rules.required] : []"
      />
    </v-form>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
// @group Common
// SelectTypes component
export default {
  name: 'SelectTypes',

  mixins: [RulesMixin],

  props: {
    // selectFn :- is name of the API call ,it is String and is Required
    selectFn: {type: String},
    // label :- is the label of the field, it is String and is Required
    label: {type: String},
    // value :- is the Id of the selected Person called in selectFn
    value: {
      type: Number,
      default: null
    },
    // placeholder :- is the String
    placeholder: {
      type: String,
      default: ''
    },
    //is required
    required: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    }
  },

  data() {
    return {
      loading: false,
      types: [],
      select: null,
      valid: true
    }
  },
  watch: {
    value: {
      handler: function () {
        this.select = JSON.parse(JSON.stringify(this.value))
      },
      deep: true
    },
    select() {
      // @vuese
      //- Tell parent we've changed the value
      this.$emit('input', this.select == null ? null : this.select)
    }
  },

  created() {
    this.select = JSON.parse(JSON.stringify(this.value))
    this.querySelections()
  },

  methods: {
    // @vuese
    // On create call the querySelections function and get all the results related from db
    //Will return name and value
    // @arg call function without argument
    querySelections() {
      this.loading = true

      API[this.selectFn]()
        .then(response => {
          this.loading = false
          let names = []
          response.data.map(function (obj) {
            names.push({name: obj.name, id: obj.id})
          })

          this.types = names
        })
        .catch(error => {
          console.log('get users', error.response)
        })
    }
  }
}
</script>

<style scoped>
.v-input__control {
  padding-top: 12px !important;
  margin-top: 4px !important;
}
</style>